import React from 'react';
import LegalPage from '../legal/LegalPage';

const TermsPage: React.FC = () => <LegalPage doc='terms' />;

export default TermsPage;
